import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE } from '../../config/api';
import { FaEdit, FaTrash, FaPlus, FaStar } from 'react-icons/fa';
import './AdminReviews.css';

const AdminReviews = () => {
  const navigate = useNavigate();
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState(null);
  const [updatingStatusId, setUpdatingStatusId] = useState(null);

  const getAuthHeaders = () => {
    const token = localStorage.getItem('adminToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  useEffect(() => {
    loadReviews();
  }, []);

  const loadReviews = () => {
    axios
      .get(`${API_BASE}/api/admin/reviews`, { headers: getAuthHeaders() })
      .then((res) => setReviews(res.data.reviews || []))
      .catch(() => setReviews([]))
      .finally(() => setLoading(false));
  };

  const handleStatusChange = (id, newStatus) => {
    setUpdatingStatusId(id);
    axios
      .put(
        `${API_BASE}/api/admin/reviews/${id}`,
        { status: newStatus },
        { headers: getAuthHeaders() }
      )
      .then((res) => {
        const updated = res.data.review;
        setReviews((prev) =>
          prev.map((r) => (r.id === id ? { ...r, status: updated.status } : r))
        );
      })
      .catch((err) =>
        // eslint-disable-next-line no-alert
        alert(err.response?.data?.error || 'فشل تحديث الحالة')
      )
      .finally(() => setUpdatingStatusId(null));
  };

  const handleDelete = (id, name) => {
    if (!window.confirm(`حذف تقييم "${name}"؟`)) return;
    setDeleting(id);
    axios
      .delete(`${API_BASE}/api/admin/reviews/${id}`, { headers: getAuthHeaders() })
      .then(() => setReviews((prev) => prev.filter((r) => r.id !== id)))
      .catch((err) => alert(err.response?.data?.error || 'فشل الحذف'))
      .finally(() => setDeleting(null));
  };

  const Stars = ({ rating }) => {
    const n = Math.min(5, Math.max(0, Number(rating) || 0));
    return (
      <span className="admin-stars">
        {[1, 2, 3, 4, 5].map((i) => (
          <FaStar key={i} className={i <= n ? 'filled' : ''} />
        ))}
      </span>
    );
  };

  if (loading) return <div className="admin-loading">جاري التحميل...</div>;

  return (
    <div className="admin-reviews">
      <div className="admin-reviews-header">
        <h1 className="admin-page-title">تقييمات العملاء</h1>
        <Link to="/admin/reviews/new" className="admin-btn-primary">
          <FaPlus /> تقييم جديد
        </Link>
      </div>
      {reviews.length === 0 ? (
        <div className="admin-empty">
          لا توجد تقييمات. <Link to="/admin/reviews/new">إضافة تقييم</Link>
        </div>
      ) : (
        <div className="admin-reviews-table-wrap">
          <table className="admin-reviews-table">
            <thead>
              <tr>
                <th>العميلة</th>
                <th>التقييم</th>
                <th>النص</th>
                <th>الحالة</th>
                <th>إجراءات</th>
              </tr>
            </thead>
            <tbody>
              {reviews.map((review) => (
                <tr key={review.id}>
                  <td className="name-cell">{review.customer_name}</td>
                  <td><Stars rating={review.rating} /></td>
                  <td className="text-cell">{review.review_text?.slice(0, 60)}…</td>
                  <td>
                    <div className="status-control">
                      <span
                        className={`status-badge status-${review.status}`}
                      >
                        {review.status === 'published' ? 'منشور' : 'مسودة'}
                      </span>
                      <select
                        className="status-select"
                        value={review.status}
                        onChange={(e) =>
                          handleStatusChange(review.id, e.target.value)
                        }
                        disabled={updatingStatusId === review.id}
                      >
                        <option value="published">منشور</option>
                        <option value="draft">مسودة</option>
                      </select>
                    </div>
                  </td>
                  <td className="actions-cell">
                    <button
                      type="button"
                      className="admin-btn-icon"
                      onClick={() => navigate(`/admin/reviews/${review.id}`)}
                      title="تعديل"
                    >
                      <FaEdit />
                    </button>
                    <button
                      type="button"
                      className="admin-btn-icon danger"
                      onClick={() => handleDelete(review.id, review.customer_name)}
                      disabled={deleting === review.id}
                      title="حذف"
                    >
                      <FaTrash />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminReviews;
